import { render, staticRenderFns } from "./CreateTsoftChannel.vue?vue&type=template&id=01e881ee&scoped=true"
import script from "./CreateTsoftChannel.vue?vue&type=script&lang=js"
export * from "./CreateTsoftChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateTsoftChannel.vue?vue&type=style&index=0&id=01e881ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e881ee",
  null
  
)

export default component.exports